import { createContext, useState } from "react";

const CustomerContext = createContext({});

export const CustomerProvider = ({ children }) => {
  const [tabs, setTabs] = useState("current");

  return (
    <CustomerContext.Provider value={{ tabs, setTabs }}>
      {children}
    </CustomerContext.Provider>
  );
};

export default CustomerContext;
